export const latestBooks = [
  {
    id: 'book-2026-01',
    title: '長風幾萬里（上）',
    author: '白鷺成雙',
    isbn: '9786269919918',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/b609b7fd-4d50-4251-93ab-25d61c34a489_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-02',
    title: '長風幾萬里（中）',
    author: '白鷺成雙',
    isbn: '9786269919925',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/4f4cf857-ef3f-47ab-a2ec-e55b2cc83faf_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-03',
    title: '長風幾萬里（下）',
    author: '白鷺成雙',
    isbn: '9786269919932',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/a8f2a09c-4788-4aeb-8ede-5550c2703d80_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-04',
    title: '不學鴛鴦老（上）',
    author: '白鷺成雙',
    isbn: '9786269919949',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/414561e6-7632-446a-86ba-81fc10850c46_compressed_-.webp',
  },
  {
    id: 'book-2026-05',
    title: '不學鴛鴦老（中）',
    author: '白鷺成雙',
    isbn: '9786269919956',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/b7adffd1-4799-465f-b45b-1f5d53dd6159_compressed_-.webp',
  },
  {
    id: 'book-2026-06',
    title: '不學鴛鴦老（下）',
    author: '白鷺成雙',
    isbn: '9786269919963',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/c62e950a-4d9a-4766-a06e-9ea768174a56_compressed_-.webp',
  },
  {
    id: 'book-2026-07',
    title: '繁華錦年，予我心安（一）',
    author: '何兮',
    isbn: '9786269919970',
    publishDate: '2026',
    tags: ['原創愛情', '情感故事'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/ab972107-113f-4e80-bba6-01b5f388b861_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-08',
    title: '繁華錦年，予我心安（二）',
    author: '何兮',
    isbn: '9786269919987',
    publishDate: '2026',
    tags: ['原創愛情', '情感故事'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/f35c083a-f0a5-43bc-aa54-8c7db6cdb8e8_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-09',
    title: '繁華錦年，予我心安（三）',
    author: '何兮',
    isbn: '9786269919994',
    publishDate: '2026',
    tags: ['原創愛情', '情感故事'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/e46702e1-4982-4f2e-8a4e-bcc593e07200_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-10',
    title: '繁華錦年，予我心安（四）（完）',
    author: '何兮',
    isbn: '9786269946006',
    publishDate: '2026',
    tags: ['原創愛情', '情感故事'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/4d98cadf-739f-4603-b995-a53ac3f812c3_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-11',
    title: '不過爾爾（上）',
    author: '白鷺成雙',
    isbn: '9786269946013',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/1744bd23-e630-46d6-ab25-44ee02756cc9_compressed_-.webp',
  },
  {
    id: 'book-2026-12',
    title: '不過爾爾（中）',
    author: '白鷺成雙',
    isbn: '9786269946020',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/e8729d12-5711-4843-99dd-2f53aa748fb5_compressed_-.webp',
  },
  {
    id: 'book-2026-13',
    title: '不過爾爾（下）',
    author: '白鷺成雙',
    isbn: '9786269946037',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/3fa2560f-ab4c-4a88-b242-49911556f9f4_compressed_-.webp',
  },
  {
    id: 'book-2026-14',
    title: '赴良宵（一）',
    author: '萌教教主',
    isbn: '9786269952007',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/3e5def95-cfe7-441f-b1a6-bf14fb05b663_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-15',
    title: '赴良宵（二）',
    author: '萌教教主',
    isbn: '9786269952014',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/65cf6e97-5beb-4923-ab32-b50663f68211_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-16',
    title: '內閣第一夫人（一）',
    author: '墨湯湯',
    isbn: '9786269952069',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/fd410b5d-8758-4e36-8e53-c2450d6acfc4_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-17',
    title: '內閣第一夫人（二）',
    author: '墨湯湯',
    isbn: '9786269952076',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/72db6867-0cc5-46b1-9579-9db883c3d765_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-18',
    title: '內閣第一夫人（三）',
    author: '墨湯湯',
    isbn: '9786269952083',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/77536eec-c8ad-4350-8cc8-11be1481dbae_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-19',
    title: '內閣第一夫人（四）（完）',
    author: '墨湯湯',
    isbn: '9786269952090',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/fb24ef3a-bf93-470c-908d-67b06f41361d_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-20',
    title: '不及皇叔貌美（上）',
    author: '白鷺成雙',
    isbn: '9786269952601',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/dadc4b9c-263e-49de-8e41-88560b36399f_compressed_9786269952601_3D_72dpi.webp',
  },
  {
    id: 'book-2026-21',
    title: '不及皇叔貌美（中）',
    author: '白鷺成雙',
    isbn: '9786269952618',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/60790e27-fbe7-4d58-aa34-c460681a7e5d_compressed_9786269952618_3D_72dpi.webp',
  },
  {
    id: 'book-2026-22',
    title: '不及皇叔貌美（下）',
    author: '白鷺成雙',
    isbn: '9786269952625',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/1a9fe790-6f5b-4478-a704-e66fcdaad237_compressed_9786269952625_3D_72dpi.webp',
  },
  {
    id: 'book-2026-23',
    title: '赴良宵（三）',
    author: '萌教教主',
    isbn: '9786269952021',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/1f764640-fbb1-43fb-acd9-895c5c0ea08f_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-24',
    title: '赴良宵（四）',
    author: '萌教教主',
    isbn: '9786269952038',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://storage.helloreaddy.io/project_files/2064586a-1a0b-4b82-8fd0-c3fe739a4cac/4116464c-6254-46d5-b96f-9083ae3bad33_compressed_unnamed.webp',
  },
  {
    id: 'book-2026-25',
    title: '風月不相關（一）',
    author: '白鷺成雙',
    isbn: '9786269958061',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: '/assets/books/9786269958061.jpg',
  },
  {
    id: 'book-2026-26',
    title: '風月不相關（二）',
    author: '白鷺成雙',
    isbn: '9786269958078',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: '/assets/books/9786269958078.jpg',
  },
  {
    id: 'book-2026-27',
    title: '赴良宵（五）',
    author: '萌教教主',
    isbn: '9786269952045',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: '/assets/books/9786269952045.jpg',
  },
  {
    id: 'book-2026-28',
    title: '赴良宵（六）（完）',
    author: '萌教教主',
    isbn: '9786269952052',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: '/assets/books/9786269952052.jpg',
  },
  {
    id: 'book-2026-29',
    title: '風月不相關（三）',
    author: '白鷺成雙',
    isbn: '9786269958085',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: '/assets/books/9786269958085.jpg',
  },
  {
    id: 'book-2026-30',
    title: '風月不相關（四）（完）',
    author: '白鷺成雙',
    isbn: '9786269958092',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20wind%20blown%20autumn%20leaves%20scattering%20across%20moonlit%20courtyard%2C%20soft%20silver%20moonlight%20and%20warm%20amber%20tones%2C%20delicate%20ink%20wash%20technique%2C%20poetic%20melancholic%20atmosphere%2C%20refined%20literary%20romance%20aesthetic%20with%20subtle%20movement%20and%20stillness%20contrast%2C%20minimalist%20composition%2C%20clean%20neutral%20background&width=600&height=900&seq=cover-series-fengyue&orientation=portrait',
  },
  {
    id: 'book-2026-31',
    title: '當春乃發生（一）',
    author: '白鷺成雙',
    isbn: '9786267715055',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: '/assets/books/9786267715055.jpg',
  },
  {
    id: 'book-2026-32',
    title: '月光酒店',
    author: '于凡',
    isbn: '9786267715109',
    publishDate: '2026',
    tags: ['情感故事', '人物成長'],
    coverUrl: '/assets/books/9786267715109.jpg',
  },
  {
    id: 'book-2026-33',
    title: '瓢蟲貼紙',
    author: '于凡',
    isbn: '9786267715116',
    publishDate: '2026',
    tags: ['情感故事', '人物成長'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20single%20ladybug%20resting%20on%20vintage%20postage%20stamp%20edge%2C%20soft%20macro%20photography%20style%2C%20warm%20cream%20paper%20texture%2C%20delicate%20nostalgic%20atmosphere%2C%20refined%20literary%20aesthetic%20with%20whimsical%20minimal%20touch%2C%20muted%20terracotta%20and%20warm%20ivory%20tones%2C%20clean%20neutral%20background&width=600&height=900&seq=cover-series-piaocong&orientation=portrait',
  },
  {
    id: 'book-2026-34',
    title: '當春乃發生（二）',
    author: '白鷺成雙',
    isbn: '9786267715062',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20tender%20green%20sprouts%20emerging%20from%20rich%20dark%20soil%20in%20early%20spring%2C%20soft%20golden%20morning%20light%20filtering%20through%2C%20delicate%20botanical%20illustration%20style%2C%20fresh%20sage%20and%20warm%20earth%20tones%2C%20refined%20literary%20aesthetic%20with%20life%20affirming%20gentle%20atmosphere%2C%20minimalist%20composition%2C%20clean%20cream%20neutral%20background&width=600&height=900&seq=cover-series-dangchun&orientation=portrait',
  },
  {
    id: 'book-2026-35',
    title: '當春乃發生（三）',
    author: '白鷺成雙',
    isbn: '9786267715079',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20tender%20green%20sprouts%20emerging%20from%20rich%20dark%20soil%20in%20early%20spring%2C%20soft%20golden%20morning%20light%20filtering%20through%2C%20delicate%20botanical%20illustration%20style%2C%20fresh%20sage%20and%20warm%20earth%20tones%2C%20refined%20literary%20aesthetic%20with%20life%20affirming%20gentle%20atmosphere%2C%20minimalist%20composition%2C%20clean%20cream%20neutral%20background&width=600&height=900&seq=cover-series-dangchun&orientation=portrait',
  },
  {
    id: 'book-2026-36',
    title: '當春乃發生（四）',
    author: '白鷺成雙',
    isbn: '9786267715086',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20tender%20green%20sprouts%20emerging%20from%20rich%20dark%20soil%20in%20early%20spring%2C%20soft%20golden%20morning%20light%20filtering%20through%2C%20delicate%20botanical%20illustration%20style%2C%20fresh%20sage%20and%20warm%20earth%20tones%2C%20refined%20literary%20aesthetic%20with%20life%20affirming%20gentle%20atmosphere%2C%20minimalist%20composition%2C%20clean%20cream%20neutral%20background&width=600&height=900&seq=cover-series-dangchun&orientation=portrait',
  },
  {
    id: 'book-2026-37',
    title: '當春乃發生（五）（完）',
    author: '白鷺成雙',
    isbn: '9786267715093',
    publishDate: '2026',
    tags: ['原創愛情', '古代言情'],
    coverUrl: 'https://readdy.ai/api/search-image?query=Elegant%20book%20cover%20design%20with%20tender%20green%20sprouts%20emerging%20from%20rich%20dark%20soil%20in%20early%20spring%2C%20soft%20golden%20morning%20light%20filtering%20through%2C%20delicate%20botanical%20illustration%20style%2C%20fresh%20sage%20and%20warm%20earth%20tones%2C%20refined%20literary%20aesthetic%20with%20life%20affirming%20gentle%20atmosphere%2C%20minimalist%20composition%2C%20clean%20cream%20neutral%20background&width=600&height=900&seq=cover-series-dangchun&orientation=portrait',
  },
];

export const allBooks = [
  ...latestBooks,
  {
    id: 'book-6',
    title: '花開的溫度',
    author: '蘇晚晴',
    publishDate: '2025.12',
    tags: ['原創愛情', '情感故事'],
    summary: '他記得每一朵她喜歡的花，也記得她說過的每一句話，但她不記得了。',
    coverSeq: 'book-cover-6',
    coverQuery: 'A%20book%20cover%20design%20with%20soft%20peach%20blossom%20illustration%20on%20cream%20background%2C%20delicate%20petal%20details%2C%20elegant%20warm%20typography%2C%20gentle%20romantic%20aesthetic%2C%20minimalist%20literary%20design%2C%20sophisticated%20spring%20atmosphere%20with%20subtle%20japanese%20influence',
    link: '/books/book-6',
  },
  {
    id: 'book-7',
    title: '月光邊境',
    author: '陳墨白',
    publishDate: '2025.10',
    tags: ['人物成長', '情感故事'],
    summary: '在人生的邊境線上，月光是唯一不需要簽證的通行證。',
    coverSeq: 'book-cover-7',
    coverQuery: 'A%20book%20cover%20with%20silver%20moonlight%20over%20a%20vast%20quiet%20field%2C%20single%20tree%20silhouette%2C%20deep%20night%20blue%20and%20muted%20silver%20tones%2C%20minimalist%20design%2C%20elegant%20literary%20fiction%20aesthetic%2C%20contemplative%20and%20serene%20atmosphere%20with%20poetic%20landscape',
    link: '/books/book-7',
  },
  {
    id: 'book-8',
    title: '我們的第二種可能',
    author: '江雨桐',
    publishDate: '2025.08',
    tags: ['人物成長', '情感故事'],
    summary: '她以為人生只有一種答案，直到她發現，愛本來就沒有標準答案。',
    coverSeq: 'book-cover-8',
    coverQuery: 'A%20book%20cover%20design%20with%20two%20intersecting%20paths%20illustrated%20in%20delicate%20gold%20lines%20on%20warm%20cream%20background%2C%20elegant%20minimalist%20typography%2C%20sophisticated%20contemporary%20women%20fiction%20aesthetic%2C%20refined%20literary%20design%20with%20subtle%20optimism%20and%20emotional%20warmth',
    link: '/books/book-8',
  },
];

export const brandInfo = {
  name: '未境原創',
  fullName: '未境原創',
  englishName: 'VIJING',
  publishingDirection: '愛情小說',
  distributor: '崧博出版事業有限公司',
  tagline: '以愛情故事延伸不同情感與人生想像',
  intro: '未境原創以愛情小說為主要出版方向，透過不同人物、情感與故事情境，呈現愛情關係及人生經歷中的多元面貌。網站提供未境原創的品牌資訊、最新發行與既有小說作品。',
  relationship: '本品牌委託崧博出版經銷，官方網站由崧博出版製作。',
};

export const navItems = [
  { id: 'home', label: '首頁', href: '/' },
  { id: 'about', label: '品牌介紹', href: '/about' },
  { id: 'stores', label: '合作通路', href: '/stores' },
  { id: 'faq', label: '常見問題', href: '/faq' },
  { id: 'blog', label: '閱讀推薦', href: '/blog' },
];
